import PropTypes from 'prop-types';
import Icon from 'shared/components/icon/icon';
import styles from './no-videos-content.styl';

const NoVideosContent = ({ width, height }) =>
  (
    <div className={styles['no-videos']}
         style={{ width, height }}
         data-hook="noPlayer">
      <Icon className={styles.play}
            name="arrow-right-filled" />
    </div>
  );

NoVideosContent.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default NoVideosContent;



// WEBPACK FOOTER //
// ./src/widget/components/no-content/no-videos-content/no-videos-content.js